function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#636363;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M19.9,23.9H5.1c-1,0-1.7-0.8-1.7-1.7V3.6c0-1,0.8-1.7,1.7-1.7h14.8c1,0,1.7,0.8,1.7,1.7v18.5 C21.6,23.1,20.9,23.9,19.9,23.9z M5.1,2.8c-0.5,0-0.8,0.4-0.8,0.8v18.5c0,0.5,0.4,0.8,0.8,0.8h14.8c0.5,0,0.8-0.4,0.8-0.8V3.6 c0-0.5-0.4-0.8-0.8-0.8L5.1,2.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M19.3,11.1H5.6V4.6h13.7V11.1z M6.5,10.1h11.9V5.6H6.5V10.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M19.3,21.1h-4.6v-8.2h4.6V21.1z M15.7,20.2h2.7v-6.4h-2.7V20.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M9.3,21.1H5.6v-3.7h3.7V21.1z M6.5,20.2h1.8v-1.8H6.5V20.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M13.9,21.1h-3.7v-3.7h3.7V21.1z M11.1,20.2h1.8v-1.8h-1.8V20.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M9.3,16.6H5.6v-3.7h3.7V16.6z M6.5,15.6h1.8v-1.8H6.5V15.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M13.9,16.6h-3.7v-3.7h3.7V16.6z M11.1,15.6h1.8v-1.8h-1.8V15.6z"
}));

var SvgIcCalculator = function SvgIcCalculator(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    width: 25,
    height: 25,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCalculator, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_calculator.566dd6bb.svg";
export { ForwardRef as ReactComponent };